define('views/parts/menu/menu-save-action',[
    'underscore', 'backbone',
    // services
    'services/i18n',
    // models
    'models/parts/menu/save-button',
    // views
    'views/parts/menu/menu-action',
], function(
    _, Backbone, i18n,
    // models
    MSaveButton,
    // views
    VMenuAction
) {

    var VMenuSaveAction = VMenuAction.extend({
        initialize: function(options) {
            options = this.options = _.extend({}, options);

            var saveItem = this.saveItem = new MSaveButton({
                    title: i18n.t("messages:tooltip-save-button"),
                    callback: options.onSave,
                    content: options.saveText || i18n.t("general:Save"),
                    icon: options.saveIcon
                }),
                collection = this.collection;

            if (!collection) {
                collection = this.collection = new Backbone.Collection([]);
            }

            collection.add(saveItem);

            VMenuSaveAction.__super__.initialize.call(this, options);
        },

        toggleSaveButton: function(val) {
            this.saveItem.set('disabled', val);
        },

    });

    return VMenuSaveAction;
});

